





import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @deprecated Use regular cells with Money.
 */
@Component({
    components: {JdsMoney}
})
export default class JdsTableCurrencyCell extends Vue {
    @Prop() amount!: number;
    @Prop() currency!: string;
}
